import gql from "graphql-tag";

export default gql`
  query sectionArticles($siteId: [QueryArgument], $topicId: [QueryArgument], $tagSlug: [String], $offset: Int!) {
    tags(siteId: $siteId, relatedToEntries: {}) {
      id
      title
      slug
      # TODO: investiguer pourquoi ça été ajouté
      # seo {
      #   description
      #   title
      # }
    }
    articles: entries(
      section: "article"
      relatedToCategories: { id: $topicId }
      relatedToTags: { slug: $tagSlug }
      siteId: $siteId
      limit: 12
      offset: $offset
      orderBy: "postDate DESC"
    ) {
      id
      ... on article_default_Entry {
        title
        slug
        excerpt
        postDate @formatDateTime(format: "d F Y")
        image {
          png_image1x: url(width: 270, height: 160, format: "png")
          png_image2x: url(width: 540, height: 320, format: "png")
          png_image3x: url(width: 810, height: 480, format: "png")
          webp_image1x: url(width: 270, height: 160, format: "webp")
          webp_image2x: url(width: 540, height: 320, format: "webp")
          webp_image3x: url(width: 810, height: 480, format: "webp")
          ... on images_Asset {
            url
          }
        }
        articleTags {
          ... on tags_Tag {
            title
            slug
          }
        }

        topicCategory {
          url
        }

        seoArticle {
          description
          title
        }
      }
    }
    total: entryCount(
      section: "article"
      relatedToCategories: { id: $topicId }
      relatedToTags: { slug: $tagSlug }
      siteId: $siteId
    )
  }
`;
